/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import {
    ElButton,
    ElIcon,
    ElTable,
    ElTableColumn,
    ElInput,
    ElForm,
    ElFormItem,
    ElInputNumber,
    ElCheckbox,
    ElDialog,
    ElTooltip,
    ElLoading
} from 'element-plus'
// 仅引入实际使用组件的样式（ElTableColumn 无独立样式，复用 table）
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/icon/style/css'
import 'element-plus/es/components/table/style/css'
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/form/style/css'
import 'element-plus/es/components/form-item/style/css'
import 'element-plus/es/components/input-number/style/css'
import 'element-plus/es/components/checkbox/style/css'
import 'element-plus/es/components/dialog/style/css'
import 'element-plus/es/components/tooltip/style/css'
import 'element-plus/es/components/loading/style/css'
// ElMessage 为函数式调用（各组件内按需 import），只需引入样式
import 'element-plus/es/components/message/style/css'
// 仅注册实际使用的 6 个图标（原先全量注册约 300 个）
import { Refresh, Search, ChatLineSquare, Operation, Plus, InfoFilled } from '@element-plus/icons-vue'
import { createRouter, createWebHistory } from "vue-router";

const app = createApp(App)

// 按需注册组件（命名数组写法：下一行以标识符开头，不会与上一行被误连，无需行首分号）
const components = [
    ElButton,
    ElIcon,
    ElTable,
    ElTableColumn,
    ElInput,
    ElForm,
    ElFormItem,
    ElInputNumber,
    ElCheckbox,
    ElDialog,
    ElTooltip
]
components.forEach(component => app.use(component))

// 注册 v-loading 指令
app.use(ElLoading)

// 全局注册实际使用的 6 个图标
const icons = [Refresh, Search, ChatLineSquare, Operation, Plus, InfoFilled]
icons.forEach(icon => app.component(icon.name, icon))

const router = createRouter({
    history: createWebHistory(),
    // history: createWebHashHistory(),
    routes: [
        {
            path: "/",
            name: "Home",
            component: () => import("@/components/Home.vue")
        },
        {
            path: "/detail",
            name: "Detail",
            component: () => import("@/components/Detail.vue")
        },
        {
            path: "/admin",
            name: "Admin",
            component: () => import("@/components/Admin.vue"),
            beforeEnter: (to) => {
                const user = localStorage.getItem('user')
                console.log('--> router, user:', user)
                if (!user) return '/login'
                return true
            }
        },
        {
            path: "/login",
            name: "Login",
            component: () => import("@/components/Login.vue")
        },
        {
            path: "/feedback",
            name: "Feedback",
            component: () => import("@/components/Feedback.vue")
        }
    ]
});
app.use(router)

app.mount('#app')
